
export const STATUS_WORKING = {
  creating: true,
  saving: true,
  deleting: true
}
